module.exports = __webpack_public_path__ + "img/dota.ac905002.jpg";